/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { AutoMailActionTypes } from '../../action/auto_action/AutoMailActions'
import { AutoActionMailConfigState } from '../state/AutoActionMailConfigState'

class AutoActionMailStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new AutoActionMailConfigState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoMailActionTypes.fetchRooms:
        return state

      case AutoMailActionTypes.fetchOne:
        return state.mergeModel(payload)

      case AutoMailActionTypes.onCreate:
        return state.clear()

      case AutoMailActionTypes.onEdit:
        return state.updateValue(payload.name, payload.value)

      default:
        return state
    }
  }
}

export default new AutoActionMailStore()
